import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dzjqu3hvk: FaireProductEntity = {
  token: "p_6dzjqu3hvk",
  type: "product",
  name: "Subtle Tea Sweet - 16 oz. - Case (12 Bottles)",
  brandToken: "b_2zlerrpi5b",
  brandName: "Subtle Tea",
  imageUrl:
    "https://cdn.faire.com/fastly/b635c7ceeaa10e95376a77514173a8ba16ef9a55b3b8b6ba79d81e6cff149541.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc2138777500e7f263b35530996a17f1177aee987f088e9e533b5cef8537e696.jpeg",
    "https://cdn.faire.com/fastly/fdde839b1c45850fa748a4c1348d247c36952bf1b1ec2296b3fe33c776659907.jpeg",
    "https://cdn.faire.com/fastly/ce1818fc45e850a68076b9f4abe176ad1d1528b8b43070773dd000373e9469b9.jpeg",
  ],
  priceDollars: 2.76,
  description:
    'All organic craft brewed iced tea, "Taste Tea First"\n\nSubtly Sweet Iced Tea\n\nEverything we do is Subtle, ok- well not everything but our line of organic teas is based around the whole "Subtle" thing and it wouldn\'t be complete without an ode to the southern favorite. Unlike the south, which doesn\'t do many things subtly, the sweetness in our Sweet Tea is just the perfect amount of organic cane sugar without being too crazy.',
  tags: [],
  msrpDollars: 5.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:47.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
